/* eslint-disable react/require-default-props */
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { AirlineLogo } from "../../assets/index";
import { getDate, getHours } from "../../utils/index";
import { IArrival, IDeparture } from "../../@types/flight-order";

export interface FlightHistoryCardProps {
  locator: string;
  changed?: boolean;
  arrival: IArrival;
  departure: IDeparture;
}

const FlightHistoryCard: FC<FlightHistoryCardProps> = ({ locator, changed = false, arrival, departure }) => {
  const { t } = useTranslation("flightCard");

  return (
    <div className="flight-history-card">
      {changed && <span className="flight-card__tag">{t("changedFlight")}</span>}

      {/* Localizador */}
      <div className="flight-card__locator">
        <div className="flight-card__locator--desktop">
          <div className="flight-card__title flight-card__locator-title">{t("locator")}</div>
          <div className="flight-card__locator-info">
            <div className="flight-card__icon flight-card__icon--medium flight-card__icon--rotate flight-card__locator-icon mb-0">
              <span className="material-icons">&#xe195;</span>
            </div>
            <div className="flight-card__locator-text">{locator}</div>
          </div>
        </div>

        <div className="flight-card__locator--mobile">
          <div className="flight-card__locator-cia">
            <img className="airlineLogo" src={AirlineLogo} alt={t("alt")} />
          </div>
          <div className="flight-card__title flight-card__locator-title">
            {t("locator")}: {locator}
          </div>
        </div>
      </div>

      {/* Origem e Destino */}
      <div className="flight-card__originDestiny">
        <div className="icon-title-mobile">
          <div className="flight-card__icon flight-card__icon--medium desktop-none">
            <span className="material-icons">&#xe935;</span>
          </div>
          <div className="flight-card__title flight-card__originDestiny-title">{t("originAndDestiny")}</div>
        </div>

        <div className="flight-card__originDestiny-info">
          <div className="flight-card__originDestiny-origin" data-testid="origin">
            <span>{getHours(departure.date, "h")}</span> <span>{departure.airport.code}</span>
          </div>

          <div className="flight-card__icon flight-card__icon--small flight-card__icon--rotate flight-card__originDestiny-icon">
            <span className="material-icons">&#xe195;</span>
          </div>

          <div className="flight-history-card__originDestiny-destiny" data-testid="destiny">
            <span>{arrival.airport.code}</span>
          </div>
        </div>
      </div>

      {/* Data/Hora */}
      <div className="flight-card__datetime">
        <div className="flight-history-card__title-icon">
          <div className="flight-card__icon flight-card__icon--medium">
            <span className="material-icons">&#xe935;</span>
          </div>

          <div className="flight-history-card__title-icon__title">{t("date")}</div>
        </div>

        <div className="flight-card__datetime-info">{getDate(departure.date)}</div>
      </div>
    </div>
  );
};

export default FlightHistoryCard;
